export abstract class TreeNode<TContainer, TLeaf> {
  abstract readonly kind: 'container' | 'leaf';
}
